<div class="charging-page" *ngIf="!isTransactionStopped; else thankYouTemplate">
  <header class="charging-header">
    <a class="brand" href="/"><img *ngIf="tenantLogo" [src]="tenantLogo" alt="Logo" class="tenant-logo"><span *ngIf="!tenantLogo">{{ tenantName || 'HubEx' }}</span></a>
    <div class="header-right">
      <div class="header-title"><mat-icon>ev_station</mat-icon><span>{{'Charging.charging' | translate}}</span></div>
      <div class="lang-selector">
        <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
        <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
        <button class="lang-btn" [class.active]="selectedLanguage === 'fa'" (click)="changeLanguage('fa')">فا</button>
      </div>
    </div>
  </header>

  <main class="charging-main">
    <section class="station-heading">
      <div>
        <span class="session-status" [class.is-active]="transactionId"><span></span>{{ (transactionId ? 'qrcode.charging_status_active' : 'qrcode.charging_status_ready') | translate }}</span>
        <h1>{{ stationName || ('qrcode.charging_Station' | translate) }}</h1>
        <div class="station-meta">
          <span><mat-icon>location_on</mat-icon>{{ stationAddress || '-' }}</span>
          <span><mat-icon>ev_station</mat-icon>{{'qrcode.connector' | translate}} {{ connectorId }} <ng-container *ngIf="connectorLabel">({{ connectorLabel }})</ng-container></span>
        </div>
      </div>
      <div class="wallet-chip" *ngIf="walletBalance > 0"><mat-icon>account_balance_wallet</mat-icon><span>{{'qrcode.wallet_current_balance' | translate}}</span><strong>{{ formatAmount(walletBalance) }} {{'qrcode.currency_irr' | translate}}</strong></div>
    </section>

    <section class="waiting-layout" *ngIf="!transactionId">
      <article class="waiting-card">
        <div class="waiting-icon"><mat-icon>bolt</mat-icon></div>
        <h2>{{'qrcode.charging_wait_title' | translate}}</h2>
        <p>{{'qrcode.charging_wait_desc' | translate}}</p>
        <button mat-flat-button class="start-button" [disabled]="transactoinStarted" (click)="startTransaction()">
          <mat-spinner diameter="20" *ngIf="transactoinStarted"></mat-spinner>
          <span *ngIf="!transactoinStarted">{{'Charging.start' | translate}}</span>
          <mat-icon *ngIf="!transactoinStarted">play_circle</mat-icon>
        </button>
      </article>
      <article class="station-detail-card">
        <span>{{'qrcode.charging_details' | translate}}</span>
        <div><mat-icon>ev_station</mat-icon><p><small>{{'qrcode.charging_Station' | translate}}</small><strong>{{ chargingStationId || '-' }}</strong></p></div>
        <div><mat-icon>power</mat-icon><p><small>{{'qrcode.connector' | translate}}</small><strong>{{ connectorId }} - {{ connectorStatus || '-' }}</strong></p></div>
        <div><mat-icon>location_on</mat-icon><p><small>{{'Charging.location' | translate}}</small><strong>{{ stationAddress || '-' }}</strong></p></div>
      </article>
    </section>

    <section class="charging-dashboard" *ngIf="transactionId">
      <article class="charge-ring-card">
        <div class="energy-wrap" role="group" [attr.aria-label]="('Charging.delivered' | translate)">
          <mat-icon>energy_savings_leaf</mat-icon>
          <strong>{{ energyInKWh | number:'1.2-2' }} <small>kWh</small></strong>
          <span>{{'Charging.delivered' | translate}}</span>
        </div>
        <div class="live-chips">
          <span><i></i>{{'Charging.charging' | translate}}</span>
          <span><mat-icon>bolt</mat-icon>{{ currentPowerInKw | number:'1.1-1' }} kW</span>
        </div>
      </article>

      <section class="charging-stats">
        <article class="cost-card">
          <div class="stat-heading"><span class="stat-icon blue"><mat-icon>payments</mat-icon></span><span>{{'Charging.price' | translate}}</span></div>
          <div class="cost-value">{{ formatAmount(transactionDetails.currentCumulatedRoundedPrice) }} <small>{{'qrcode.currency_irr' | translate}}</small></div>
          <div class="cost-line"><span></span></div>
        </article>

        <div class="split-stats">
          <article class="metric-card"><mat-icon>schedule</mat-icon><span>{{'Charging.duration' | translate}}</span><strong>{{ formattedDuration }}</strong></article>
          <article class="metric-card"><mat-icon>bolt</mat-icon><span>{{'qrcode.charging_power' | translate}}</span><strong>{{ currentPowerInKw | number:'1.1-1' }} kW</strong></article>
        </div>

        <button mat-flat-button class="stop-button" [disabled]="isStopRequested" (click)="stopTransaction(dialogService, translateService)"><mat-icon>stop_circle</mat-icon>{{'Charging.stop' | translate}}</button>
      </section>
    </section>

    <section class="session-details" *ngIf="transactionId">
      <div><span>{{'qrcode.charging_details' | translate}}</span><strong>#{{ transactionDetails.id }}</strong></div>
      <div><span>{{'qrcode.charging_Station' | translate}}</span><strong>{{ transactionDetails.chargeBoxID }}</strong></div>
      <div><span>{{'qrcode.connector' | translate}}</span><strong>{{ transactionDetails.connectorId }}</strong></div>
      <div><span>{{'qrcode.charging_power' | translate}}</span><strong>{{ currentPowerInKw | number:'1.1-1' }} kW</strong></div>
    </section>
  </main>
</div>

<ng-template #thankYouTemplate>
  <div class="thank-you-page">
    <header class="charging-header">
      <a class="brand" href="/"><img *ngIf="tenantLogo" [src]="tenantLogo" alt="Logo" class="tenant-logo"><span *ngIf="!tenantLogo">{{ tenantName || 'HubEx' }}</span></a>
      <div class="header-right">
        <div class="lang-selector">
          <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
          <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
          <button class="lang-btn" [class.active]="selectedLanguage === 'fa'" (click)="changeLanguage('fa')">فا</button>
        </div>
      </div>
    </header>
    <main class="thank-you-content">
      <div class="thank-you-card">
        <mat-icon>check_circle</mat-icon>
        <h1>{{'qrcode.charging_thank_you' | translate}}</h1>
        <p class="thank-you-subtitle">{{'qrcode.charging_revisit' | translate}}</p>
      </div>
      <div class="session-summary">
        <h2>{{'qrcode.session_summary' | translate}}</h2>
        <div class="summary-row">
          <mat-icon>payments</mat-icon>
          <span class="summary-label">{{'Charging.price' | translate}}</span>
          <strong class="summary-value">{{ formatAmount(finalPrice) }} {{'qrcode.currency_irr' | translate}}</strong>
        </div>
        <div class="summary-row">
          <mat-icon>schedule</mat-icon>
          <span class="summary-label">{{'Charging.duration' | translate}}</span>
          <strong class="summary-value">{{ finalDuration }}</strong>
        </div>
        <div class="summary-row">
          <mat-icon>energy_savings_leaf</mat-icon>
          <span class="summary-label">{{'Charging.delivered' | translate}}</span>
          <strong class="summary-value">{{ finalEnergy | number:'1.2-2' }} kWh</strong>
        </div>
      </div>
    </main>
  </div>
</ng-template>
